export { TradingPlatform as ApiPlatform } from '@/api/schema';

export type ISO8601DateTimeString = string;

export type LowercaseEnumRecord<T extends Record<string, string | number>> = {
  [K in keyof T as K extends string ? Lowercase<K> : never]: T[K] extends string ? Lowercase<T[K]> : T[K];
};

export type Timestamp = number;
